export default __webpack_public_path__ + "static/media/sports_banner_3.5b17c40d.png";